import { render } from 'preact';
import { Site } from './Site';

const root = document.getElementById('site-root');
if (root) render(<Site />, root);
